import {Box, Typography, TableContainer} from "@mui/material"
import React from "react"
import styled from "styled-components"

import {ActivePaymentPlan} from "./ActivePaymentPlan"
import {InstalmentCapSection} from "./InstalmentCap"

import type {ActivePaymentPlan as ActivePaymentPlanType} from "@indebted/api"

type PaymentPlansProps = {
	activePaymentPlans: ActivePaymentPlanType[]
	reload: () => void
	customerID: string
	totalCustomerBalance: number
}

const PaymentPlans = ({activePaymentPlans, reload, customerID, totalCustomerBalance}: PaymentPlansProps) => {
	return (
		<Box>
			{activePaymentPlans.length >= 1 ? (
				<WithActivePlans activePaymentPlans={activePaymentPlans} reload={reload} />
			) : (
				<NoActivePlans />
			)}
			<InstalmentCapSection customerID={customerID} totalCustomerBalance={totalCustomerBalance} />
		</Box>
	)
}

const WithActivePlans = ({
	activePaymentPlans,
	reload,
}: {
	activePaymentPlans: ActivePaymentPlanType[]
	reload: () => void
}) => (
	<StyledTableContainer>
		{activePaymentPlans.map((paymentPlan, index) => (
			<ActivePaymentPlan
				paymentPlan={paymentPlan}
				reload={reload}
				key={paymentPlan.ID}
				activePaymentPlanNumber={index + 1}
			/>
		))}
	</StyledTableContainer>
)

const NoActivePlans = () => (
	<Box m={8}>
		<Typography variant="subtitle1">No active payment plans</Typography>
	</Box>
)

const StyledTableContainer = styled(TableContainer)`
	margin-top: 20px;
`

export {PaymentPlans}
